import React from 'react';

import { type EmojiId } from '@app/client';

import { YatImageDisplay } from '../YatImageDisplay';

import './_DisplayPill.scss';

interface YatDisplayPillProps {
    currentYat: EmojiId;
}
const YatDisplayPill = ({ currentYat }: YatDisplayPillProps) => {
    return (
        <div className="yat-display-pill">
            <YatImageDisplay emojiID={currentYat} imageHeight={42} />
        </div>
    );
};

export default YatDisplayPill;
